import { Component } from '@angular/core';
import { MainArea } from '../core/enums/main-area.enum';

@Component({
	selector: 'lib-campaign-management',
	templateUrl: './campaign-management.component.html',
	styleUrls: [],
})
export class CampaignManagementComponent {
	public currentView: MainArea = MainArea.CampaignIndex;
	public currentViews = MainArea;

	constructor() {
		/* Init Localstorage (Local Only) */
		/* const data = {
			'telin.accessToken':
				'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IlBST1ZJREVSIiwiZXhwIjoxNzA4MDAyNzI4LCJpYXQiOjE3MDc5Nzg3MjgsIm5iZiI6MTcwNzk3ODcyOCwic2Vzc2lvbklkIjoiMDFIUE5RRTk5N0E3SkZLNjk1QTgyWEtTWkEiLCJ1c2VySWQiOiJhZG1pbiJ9.JWn1gRtlU6SYHa3KkP2FLhje9tvhxsD005dtxmTT5z4-lc65ekiClS5r7Wg8vamUappN_9uQINTJeZCjEU1IwYf6InUddxX6XsDWtCwixuePNq4JZMPrCUl_N4DBewPwL30RRrodoo0dxUstHLbTg9BUZ3qPq1QK6pLyd1HhKtN_jkRJ11VP2hEl6ef364ofmZvByDTKO56ah0GYzpxZ1uxvNV9PsyiuQk_drxE6x7PI7n-yH_H00zauMF6FYhTgv0SbqIRGQr-O8MKl1mbmk3efSdEr3gx6Q-bztG8p_jgOPWjVf4ol_6gfqtMOrlxTe2UJeR23fhWXCbp0ld20HpjgeIlkawoqpj8_TsjsnsPYk5epC2h5YVXrCuozWw5GnxYg7LDSx0CGQhe2JNRSy92b3hSvSahTQ0rKbmVDyvCIcRVhk2RO4Ilc-ddx4HhB8fcvbSVTAPBnI0A9NkPKSYKXA5SwiIlcPqex15BBG4zBbEX7D4JWr4925t2--WXkUIjsKvteOx0u9OhcBTbajahVepTNByNyqdKrJzdShWTBXw4mRNprL57ZZ3qFdCA6-11FcmeRkpDRqUX7kAXloFKBtcOECNjUpLNkf4FmT687-gt1R0xGIJsTatLSsc2K4Xr1TpTiuC7D3xledvsGTC07UuDgVQBb7AkN1Kch3Mg',
			'telin.clientId': 'PROVIDER',
			'telin.clientName': 'Provider',
			'telin.email': 'admin@bsp.com',
			'telin.id': 'admin',
			'telin.name': 'admin',
			'telin.roleCode': 'admin',
			'telin.roleId': 'admin',
			'telin.roleName': 'Administrator',
			'telin.roles':
				'[{"isClientRole":false,"name":"Administrator","code":"admin","id":"admin"}]',
		};

		Object.keys(data).forEach(function (k) {
			localStorage.setItem(k, data[k]);
		}); */
		/* Init Localstorage (Local Only) */
	}

	onChangeMainArea(area: MainArea): void {
		this.currentView = area;
	}
}
